import { render, staticRenderFns } from "./BuyEstar.vue?vue&type=template&id=9a22c670&scoped=true"
import script from "./BuyEstar.vue?vue&type=script&lang=js"
export * from "./BuyEstar.vue?vue&type=script&lang=js"
import style0 from "./BuyEstar.vue?vue&type=style&index=0&id=9a22c670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a22c670",
  null
  
)

export default component.exports